import { Col, Row, Sidepanel, Spinner2, Text } from 'components';
import { theme } from 'lib';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Game, Settings } from './components';

const GamePanel = ({ dataId, closeModal }) => {
  const [loading, setLoading] = useState(false);
  const data = useSelector((state) => state.admin?.games?.find((x) => x._id === dataId));

  return (
    <React.Fragment>
      <Sidepanel wid={600} pad="0" visible={dataId} closeModal={closeModal}>
        <Col pos="sticky" bg="#000" center top="0" pad="0 0 13px">
          <Row between center pad="12px 24px 0">
            <Text h3 col="#fff">
              {!!data && `${data.home.name} - ${data.away.name}`}
            </Text>

            <Settings
              loading={loading}
              setLoading={setLoading}
              game={data}
              closePanel={closeModal}
            />
          </Row>
        </Col>

        {dataId && (typeof dataId === 'string' ? !data : false) && (
          <Col
            zIndex={5}
            pos="absolute"
            ht="100%"
            wid="100%"
            bg="rgba(210, 216, 223, 0.7)"
            left="0"
            centerAll
          >
            <Spinner2 col={theme.SECONDARY} />
          </Col>
        )}

        {dataId && (typeof dataId === 'string' ? data : true) && (
          <Game closeModal={closeModal} data={data} />
        )}
      </Sidepanel>
    </React.Fragment>
  );
};

export default GamePanel;
